import { render } from "./Bankaccounts.vue?vue&type=template&id=1d7d9fb4&ts=true"
import script from "./Bankaccounts.vue?vue&type=script&lang=ts"
export * from "./Bankaccounts.vue?vue&type=script&lang=ts"

import "./Bankaccounts.vue?vue&type=style&index=0&id=1d7d9fb4&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__